export default __webpack_public_path__ + "static/media/jars.c77acd45.png";